import { EntityHistoryReferenceDto } from '../entity-history-timeline.types';
import { useEntityHistoryReferencesStyles } from './entity-history-timeline-references.styles';

export function EntityHistoryTimelineReferences({ references }: { references: EntityHistoryReferenceDto[] }) {
  const classes = useEntityHistoryReferencesStyles();

  return (
    <div className={classes.wrapper}>
      {references.map((ref) => (
        <span key={ref.id} className={classes.reference}>
          {ref.contextLabel} <span className={classes.label}>{ref.label}</span>
        </span>
      ))}
    </div>
  );
}
